import { Link } from 'react-router-dom';

const pageLinks = [
  { label: 'Home', path: '/' },
  { label: 'Services', path: '/services' },
  { label: 'About', path: '/about' },
  { label: 'Testimonials', path: '/testimonials' },
  { label: 'Contact', path: '/contact' },
];

export default function Footer() {
  return (
    <footer className="bg-brand-green w-full">
      <div className="w-full px-6 lg:px-12 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Brand */}
          <div>
            <img
              src="https://storage.readdy-site.link/project_files/a87775cd-cdf2-4bef-9fc3-2b80005013bf/ec189a36-2d98-4215-8215-aef98763cb82_Asset-44x.png?v=54ceffc747a4cefb1907ce855a86246f"
              alt="Holston Land Management"
              className="h-12 w-auto object-contain mb-4"
            />
            <p className="font-heading text-lg font-700 tracking-widest text-white uppercase mb-2">
              Holston Land Management
            </p>
            <p className="font-body text-sm text-green-200 leading-relaxed max-w-xs">
              Professional land services. Based in Northeast TN, serving customers nationwide.
            </p>
          </div>

          {/* Pages */}
          <div>
            <h4 className="font-heading font-700 text-sm tracking-widest uppercase text-white mb-4">
              <a href="#">Quick Links</a>
            </h4>
            <ul className="flex flex-col gap-2">
              {pageLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="font-body text-sm text-green-200 hover:text-white transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-700 text-sm tracking-widest uppercase text-white mb-4">
              <a href="#">Contact</a>
            </h4>
            <ul className="flex flex-col gap-3">
              <li className="flex items-center gap-3 text-green-200">
                <div className="w-5 h-5 flex items-center justify-center shrink-0">
                  <i className="ri-phone-line text-brand-green-accent" />
                </div>
                <a href="tel:+14236780298" className="font-body text-sm hover:text-white transition-colors cursor-pointer">
                  (423) 678-0298
                </a>
              </li>
              <li className="flex items-center gap-3 text-green-200">
                <div className="w-5 h-5 flex items-center justify-center shrink-0">
                  <i className="ri-mail-line text-brand-green-accent" />
                </div>
                <a href="mailto:projects@holstonlandmgmt.com" className="font-body text-sm hover:text-white transition-colors cursor-pointer">
                  projects@holstonlandmgmt.com
                </a>
              </li>
              <li className="flex items-start gap-3 text-green-200">
                <div className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-brand-green-accent" />
                </div>
                <span className="font-body text-sm">Northeast Tennessee</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-green-700 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-body text-xs text-green-300">
            &copy; {new Date().getFullYear()} Holston Land Management. All rights reserved.
          </p>
          <p className="font-body text-xs text-green-300">
            Based in Northeast TN &middot; Serving Customers Nationwide
          </p>
        </div>
      </div>
    </footer>
  );
}
